export const dayNewsMixin = {
    methods: {
        getDayNews: function () {
            document.location.reload();
        }
    },
    created: function () {
        this.$refreshHub.$on("atento-update", this.getDayNews);
    },
    updated: function () {
        if (document.location.hash) {
            const _self = this;
            document.addEventListener("lrload", () => {
                setTimeout(() => {
                    _self.$scrollTo(document.location.hash, 600, {
                        offset: -110,
                    })
                }, 200);
            });
        }
    }
};